import { HttpService } from 'core/modules/network-service';

/*************************************************************/
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc CallWidgetItemDetailSummary defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallWidgetItemDetailSummaryService } from 'services/callWidgetItemDetailSummary';
 *
 * // create service instance and send/cancel request
 * const callWidgetItemDetailSummaryService = new CallWidgetItemDetailSummaryService();
 * const result = await callWidgetItemDetailSummaryService.fetchData( '<user-id>' ); // fetch data
 * callWidgetItemDetailSummaryService.cancel(); // cancel an active request
 */
export class CallWidgetItemDetailSummaryService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            const state =  [ get( response, 'body.component.data.state', {} ) ];

            response.body.component.data.state = { items: state };
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component', {} ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async fetchMarkResolvedData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.structure', {} ),
                    options: get( response, 'body.component.data.options', [] ),
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async markResolvedData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                _status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
